// JSON-LD Schema generators for SEO
interface Product {
  id: number
  name: string
  price: number
  originalPrice?: number
  image: string
  brand?: string
  rating?: number
  reviewCount?: number
  description?: string
}
interface BreadcrumbItem {
  label: string
  href?: string
}
export function generateProductJsonLd(product: Product) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    image: product.image,
    description: product.description || product.name,
    brand: {
      '@type': 'Brand',
      name: product.brand || 'Innova Pharmacy',
    },
    offers: {
      '@type': 'Offer',
      url: `https://www.innovaksa.net/product/${product.id}`,
      priceCurrency: 'SAR',
      price: product.price.toString(),
      priceValidUntil: new Date(
        Date.now() + 30 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      availability: 'https://schema.org/InStock',
      seller: {
        '@type': 'Organization',
        name: 'Innova Pharmacy',
      },
    },
    ...(product.rating && {
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: product.rating.toString(),
        reviewCount: product.reviewCount?.toString() || '1',
        bestRating: '5',
        worstRating: '1',
      },
    }),
  }
}
export function generateBreadcrumbJsonLd(items: BreadcrumbItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      ...(item.href && {
        item: `https://www.innovaksa.net${item.href}`,
      }),
    })),
  }
}
export function generateItemListJsonLd(
  products: Product[],
  categoryName: string,
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: categoryName,
    numberOfItems: products.length,
    itemListElement: products.map((product, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: `https://www.innovaksa.net/product/${product.id}`,
      name: product.name,
      image: product.image,
    })),
  }
}
export function generateOrganizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Innova Pharmacy',
    url: 'https://www.innovaksa.net',
    logo: 'https://www.innovaksa.net/logo.png',
    description:
      'Your trusted online pharmacy in Saudi Arabia for authentic health and beauty products with fast delivery.',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'SA',
      addressLocality: 'Riyadh',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+966-XXX-XXXX',
      contactType: 'customer service',
      areaServed: 'SA',
      availableLanguage: ['en', 'ar'],
    },
    sameAs: [
      'https://www.facebook.com/innovaksa',
      'https://www.twitter.com/innovaksa',
      'https://www.instagram.com/innovaksa',
    ],
  }
}
export function generateWebsiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Innova Pharmacy',
    url: 'https://www.innovaksa.net',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://www.innovaksa.net/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  }
}
